<template>
  <div>
    <v-row>
      <v-col cols="12" v-if="expert">
        <VueCtkDateTimePicker v-bind="$attrs" input-size="lg" v-model="created_at" :dark="$vuetify.theme.dark"
          color="$vuetify.theme.currentTheme.primary" hint="Niestandardowy czas zdarzenia"
          label="Wybierz datę i godzinę" format="YYYY-MM-DD HH:mm" formatted="dddd, DD MMMM YYYY HH:mm">
        </VueCtkDateTimePicker>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" lg="3" xl="2">
        <v-select outlined dense return-object hide-details v-model="categorySelected" :items="categories"
          :item-text="(item) => item.name" label="Kategoria">
        </v-select>
      </v-col>
      <v-col cols="12" md="8" lg="9" xl="10">
        <code-combo :code="code" :category="categorySelectedParam" @code-selected="codeSelected" />
      </v-col>
      <v-col cols="12">
        <v-text-field dense v-model="info" :label="$t('event.info')" outlined hide-details="false"></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import EventService from "@/services/event.service"
import { CategoryId } from '@/store/modules/event'
// import { format } from "date-fns"

export default {
  name: "EventEditor",

  beforeMount() {
    this.reset()
  },
  props: {
    autocommit: {
      type: Boolean,
      default: false
    },
    expert: {
      type: Boolean,
      default: false
    },
    event: {
      type: Object,
      default: () => {
        return {
          created_at: null,
          code: null,
          site: null,
          details: { info: "" }
        }
      }
    }
  },
  data: () => ({
    created_at: null,
    info: null,
    categories: EventService.getCategoryConditions(),
    categorySelected: null, //this.categories[0],
    code: null,
    syncCategoryFromCode: false,
  }),
  watch: {
    event: function() {
      console.log("event update :>> ", this.event)
      this.reset()
    },
    created_at: function() {
      console.log('watch: this.created_at :>> ', this.created_at);
      if (this.autocommit) {
        this.event.created_at = new Date(this.created_at).toISOString()
      }
    },
    categorySelected() {
      if (this.syncCategoryFromCode) {
        this.syncCategoryFromCode = false
        return
      }
      this.code = null
    },
    info: function() {
      if (this.autocommit) {
        this.event.details.info = this.info
      }
    }
  },
  filters: {},
  computed: {
    categorySelectedParam() {
      return this.categorySelected?.params?.category ?? null
    },
    maxDate() {
      const max = this.$options.filters.localDateTime(new Date())
      console.log('max :>> ', max);
      return max
    }
  },
  methods: {
    codeAsString: item =>
      item.code + " " + item.text + " [" + item.category + "]",
    update() {
      console.log("update event from form", this.$refs)
      if (this.created_at) {
        this.event.created_at = this.created_at
      } else {
        this.event.created_at = null
      }
      this.event.code = this.code
      this.event.details.info = this.info
      console.log("event", this.event)
    },
    codeSelected(code) {
      this.code = code
      const categoryByCode = this.findCategoryByCodeCategory(code?.category)
      if (categoryByCode && categoryByCode.id !== this.categorySelected?.id) {
        this.syncCategoryFromCode = true
        this.categorySelected = categoryByCode
      }
      if (this.autocommit) {
        this.event.code = code
      }
    },
    findCategoryByCodeCategory(codeCategory) {
      if (!codeCategory) {
        return null
      }

      const exact = this.categories.find(c => c.params?.category === codeCategory)
      if (exact) {
        return exact
      }

      const byPrefix = this.categories
        .filter(c => c.params?.category && codeCategory.startsWith(c.params.category))
        .sort((a, b) => (b.params.category.length - a.params.category.length))

      return byPrefix[0] ?? this.categories.find(c => c.code === CategoryId.ALL) ?? null
    },
    reset() {
      this.info = this.event.details.info
      this.code = this.event.code
      this.categorySelected = this.findCategoryByCodeCategory(this.event.code?.category)
      if (this.event.created_at) {
        this.created_at = this.$options.filters.localDateTime(this.event.created_at)
      } else {
        this.created_at = null
      }
      if (!this.categorySelected) {
        const auto = this.categories.find(c => c.code === CategoryId.ALARM_INTRUSION)
        if (auto) this.categorySelected = auto
      }
    }
  }
}
</script>
